import { render, staticRenderFns } from "./MentionableUser.vue?vue&type=template&id=6cab7d2c&scoped=true&"
import script from "./MentionableUser.vue?vue&type=script&lang=js&"
export * from "./MentionableUser.vue?vue&type=script&lang=js&"
import style0 from "./MentionableUser.vue?vue&type=style&index=0&id=6cab7d2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cab7d2c",
  null
  
)

export default component.exports